import React from 'react'
import { PaginaType } from 'utils/types'
import useTrans from '@hooks/useTrans'
import { ChevronLeft } from '@components/atoms/Icons'
import { Button, WContainer } from '@components/atoms'
import {
  FormRecuperaPassword,
  FormResetPassword,
  FormResendActivation,
  Page,
} from '@components/organisms'
import styles from './RecuperaPasswordTemplate.module.sass'

interface Props {
  pagina: PaginaType
  token?: string
  iframe?: boolean
  from?: string
  type: 'recupera' | 'reset' | 'resend'
}

const RecuperaPasswordTemplate = (props: Props) => {
  const { pagina, token = '', iframe, from, type } = props

  const t = useTrans()

  return (
    <Page
      pagina={pagina}
      item={{}}
      contentClassName={styles.recuperaPasswordTemplate}
      iframe={iframe}
    >
      <WContainer>
        <Button
          label={t('Torna al login')}
          href={iframe ? `/login-parto-riparto?f=${encodeURIComponent(from)}` : '/login'}
          variant="ghost"
          icon={<ChevronLeft />}
          iconPos="left"
          size="sm"
        />
      </WContainer>
      <WContainer variant="xxs">
        {(!!pagina.titolo || !!pagina.descrizione) && (
          <div className={styles.head}>
            {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
            {!!pagina.descrizione && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
              />
            )}
          </div>
        )}
        {token && type === 'reset' ? (
          <FormResetPassword token={token} />
        ) : type === 'recupera' ? (
          <FormRecuperaPassword iframe={iframe} from={from} />
        ) : type === 'resend' ? (
          <FormResendActivation />
        ) : null}
      </WContainer>
    </Page>
  )
}

export default RecuperaPasswordTemplate
